export const OUTS_PER_INNING = 3;

/** Most runs one play can score: a grand slam */
export const MAX_RUNS_PER_PLAY = 4;
